import { Input } from "@/components/ui/input";
import { rangePreset } from "@/lib/api";

const PRESETS = [
  { k: "all", label: "All time" },
  { k: "month", label: "This month" },
  { k: "last_month", label: "Last month" },
  { k: "year", label: "This year" },
];

export const DateFilters = ({ start, end, onChange }) => {
  const active = PRESETS.find((p) => {
    const r = rangePreset(p.k);
    return r.start === start && r.end === end;
  })?.k;
  return (
    <div className="space-y-3" data-testid="date-filters">
      <div className="flex flex-wrap gap-2">
        {PRESETS.map((p) => (
          <button
            key={p.k}
            type="button"
            onClick={() => onChange(rangePreset(p.k))}
            data-testid={`date-preset-${p.k}`}
            className={`h-10 px-4 rounded-full text-sm font-semibold border transition-colors ${
              active === p.k ? "bg-slate-900 text-white border-slate-900" : "bg-white text-slate-600 border-slate-200 hover:border-slate-400"
            }`}
          >
            {p.label}
          </button>
        ))}
      </div>
      <div className="grid grid-cols-2 gap-3 sm:max-w-md">
        <div>
          <label className="mt-overline block mb-1.5" htmlFor="filter-start">From</label>
          <Input id="filter-start" type="date" value={start} onChange={(e) => onChange({ start: e.target.value, end })} className="h-11" data-testid="filter-start-date" />
        </div>
        <div>
          <label className="mt-overline block mb-1.5" htmlFor="filter-end">To</label>
          <Input id="filter-end" type="date" value={end} onChange={(e) => onChange({ start, end: e.target.value })} className="h-11" data-testid="filter-end-date" />
        </div>
      </div>
    </div>
  );
};
